<template>
  <div style="padding:24px">
    <el-form :inline="true" :model="query">
      <el-form-item label="时间：">
        <el-date-picker
            v-model="query.time"
            type="daterange"
            clearable
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="resetQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="list"
        style="width: 100%">
      <el-table-column type="index" label="序号" width="140">
      </el-table-column>
      <el-table-column prop="vtime" label="时间"></el-table-column>
      <el-table-column prop="pv" label="PV"></el-table-column>
      <el-table-column prop="uv" label="UV"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="exportDetail(scope.row.vtime)">导出明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :current-page="query.pageNo"
        @current-change="handleCurrentChange"
        :total="query.total">
    </el-pagination>
  </div>
</template>

<script>
import config from "@/api/config";

export default {
  name: "dayLog",
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        time: null
      },
      list: []
    }
  },
  computed:{
    currentMeetingCode(){
      return this.$store.state.dict.currentMeetingCode;
    }
  },
  watch:{
    currentMeetingCode(){
      this.resetQuery();
    }
  },
  created(){
    this.getList()
  },
  methods:{
    resetQuery() {
      this.query.pageNo = 1;
      this.getList();
    },
    getList(){
      const obj = {...this.query}
      obj.meetingCode = this.currentMeetingCode;
      if(obj.time) {
        obj.startTime = obj.time[0];
        obj.endTime = obj.time[1];
      }
      this.$api.viewLog(obj).then(res => {
        this.list = res.data.data;
        this.query.total = res.data.totalElements;
      })
    },
    exportDetail(time) {
      let url = config.baseURL + "/crMeetingInfo/viewDataExport";
      const data = {
        meetingCode: this.currentMeetingCode,
        token: localStorage.getItem("authorization"),
        time
      }
      var form = document.createElement("form");
      for (const item in data) {
        var opt = document.createElement("input");
        // 设置相应参数
        opt.name = item;
        opt.value = data[item];
        form.appendChild(opt);
      }
      document.body.appendChild(form);
      form.method = "post";
      form.action = url;
      form.submit();
      document.body.removeChild(form);
    },
    handleCurrentChange(e) {
      this.query.pageNo = e;
      this.getList();
    }
  },
}
</script>


<style scoped lang="scss">

</style>